

















































import { Component, Prop, Vue, Watch } from "vue-property-decorator";

import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";
// @ts-ignore
import { quillEditor } from "vue-quill-editor";
import Attachments from "@/components/Controls/Attachments.vue";

@Component({
  components: {
    quillEditor,
    Attachments
  }
})
export default class CommentForm extends Vue {
  editorOption = {
    modules: {
      toolbar: [
        ["bold", "italic", "underline", "strike"],
        ["blockquote", "code-block"],
        [{ list: "ordered" }, { list: "bullet" }]
      ]
    },
    placeholder: "Введите текст ..."
  };

  form = {
    body: "",
    recipient_id: null,
    is_client_answer: false,
    attachments: []
  };
  addAttachments(file: any) {
    if (!this.form.attachments) {
      this.form.attachments = [];
    }
    // @ts-ignore
    this.form.attachments.push(file);
  }

  removeFile(idx: number) {
    this.form.attachments.splice(idx, 1);
  }

  save() {
    this.$emit("save", this.form);
  }

  cancel() {
    this.$emit("cancel");
  }
}
